/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicGDPRService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getConsentFormWrapRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsPublicGDPRService',
  rpcName: 'getConsentFormWrap',
  auth: 'external',
  fingerprint: 'ffznQ9qp3PVllPykvWpwuCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitViewerFormRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsPublicGDPRService',
  rpcName: 'submitViewerForm',
  auth: 'external',
  fingerprint: '4w0CZV31Z0SOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};